<template>
  <div class="filters-container">
    <el-row :gutter="20">
      <CustomInput
        v-model="filters.CodigoCotizacion"
        :label="'Nro Cotizacion'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar nro de cotizacion',
        }"
      />
      <CustomInput
        v-model="filters.Referencia"
        :label="'Producto'"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar producto',
        }"
      />
      <el-col :span="4">
        <div class="custom-label">Fecha desde</div>
        <el-date-picker
          v-model="filters.FechaDesde"
          type="date"
          size="default"
          placeholder="Seleccione una fecha"
          format="DD/MM/YYYY"
          style="max-width: 185px"
        />
      </el-col>
      <el-col :span="4">
        <div class="custom-label">Fecha hasta</div>
        <el-date-picker
          v-model="filters.FechaHasta"
          type="date"
          size="default"
          placeholder="Seleccione una fecha"
          format="DD/MM/YYYY"
          style="max-width: 185px"
          @change="handleFechaHastaChange"
        />
      </el-col>
      <el-col
        :span="4"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrar"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCotizacionCantidadStore } from '@/stores/cotizacion-cantidad/cotizacion-cantidad_store';
import { useProposalsStore } from '../../proposals_store';
import CustomInput from '@/shared/components/custom_input.vue';
import IconDelete from '~icons/mdi/delete';

const proposalsStore = useProposalsStore();
const { proposal } = storeToRefs(proposalsStore);

const cotizacionCantidadStore = useCotizacionCantidadStore();
const { filters } = storeToRefs(cotizacionCantidadStore);
const {
  findAllCotizacionCantidadHTTP,
  emptyList: emptyCotizacionCantidadList,
  resetFilters,
} = cotizacionCantidadStore;

const filtrar = () => {
  try {
    emptyCotizacionCantidadList();
    findAllCotizacionCantidadHTTP({
      page: 1,
      limit: 200,
      CodigoCliente: proposal.value.Cliente?.Codigo,
      CodigoEstado: 2,
    });
  } catch (error) {
    console.error('Error al filtrar cotizacion cantidades:', error);
  }
};

const handleFechaHastaChange = (value) => {
  if (value) {
    const fechaSeleccionada = new Date(value);
    fechaSeleccionada.setHours(23, 59, 59, 999);
    filters.value.FechaHasta = fechaSeleccionada;
  }
};

const LimpiarFiltros = () => {
  resetFilters();
  filtrar();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
  margin-bottom: 20px;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
.button-container {
  /* Estilo específico para el contenedor del botón */
  margin-top: auto; /* Empuja el contenido hacia abajo, ocupando la parte inferior */
}
.margin-row {
  margin-top: 1%;
}
</style>
